export const appliancesArray = [
    "Energy Start Qualified Appliances",
    "Kitchen",
    "Dryer Included",
    "Refrigerator",
    "Freestranding Oven",
    "Washer",
    "Free-Standing",
    "Dishwasher",
    "Disposal",
    "Microwave",
];
export const moreFeatureArray = [
    "Bright Airy Layout",
    "Well Appointed Kitchen",
    "2 car parking",
    "In-house Gym",
    "Pool",
    "Cozy home",
    "Central heating",
];

export const featuresArray = [
    "Bright Airy Layout",
    "Well Appointed Kitchen",
    "2 car parking",
    "In-house Gym",
    "Pool",
    "Cozy home",
    "Central heatign",
];

export const kitchenArray = [
    "Breakfast Bar",
    "Kitchen Island",
    "Pantry",
    "Kitchen open to Family Room",
    "Pots/Pans Drawers",
    "Under Cabinet Lighting",
    "Walk-in Pantry",
    "Disposal",
    "Microwave",
];

export const constructionArray = [
    "Single Family",
    "Condo",
    "Multifamily (2+ units)",
    "Townhouse",
    "Contemporary",
    "Modern",
    "Family Residence",
    "New Construction",
    "Disposal",
    "Microwave",
];
export const materialsArray = ["Slab", "Composition", "Stucco", "Tile", "Cement Sliding", "Batts Insulation"];

export const parkingArray = ["2 parknig spaces", "More than 2 parking", "Additional Parking", "More than 3 parking"];
